import './styles/fonts.css';
import './styles/tokens.css';
import './styles/app.css';

const form = document.getElementById('loginForm');
const err = document.getElementById('err');

// Only follow `next` if it's a same-origin path (no protocol-relative
// URLs, no absolute URLs). Prevents an attacker-supplied `next` from
// turning the login page into an open redirect to a phishing site.
function safeNext(raw) {
  if (typeof raw !== 'string' || !raw) return '/';
  if (raw[0] !== '/' || raw.startsWith('//') || raw.startsWith('/\\')) return '/';
  return raw;
}

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  err.textContent = '';
  const fd = new FormData(form);
  let res;
  try {
    res = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ password: fd.get('password') }),
    });
  } catch {
    err.textContent = 'Network error. Try again.';
    return;
  }
  if (res.ok) {
    const next = safeNext(new URLSearchParams(location.search).get('next'));
    location.href = next;
    return;
  }
  if (res.status === 401) err.textContent = 'Incorrect password.';
  else if (res.status === 429) err.textContent = 'Too many attempts. Try again later.';
  else err.textContent = 'Sign-in failed. Try again.';
});
